/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {

  production: true,
  appname: 'Fernando Conrado',
  urlbase: 'https://api-fernandoconrado.entregadigital.app.br/api/v1/pwa/',

  ds: '&dM4_', // Descryptor Hash

  oneSignalAppID: '6e2ac438-ad35-43ef-8388-9a1b929c5fd8',
  oneSignalSafariWebID: '',
  subdomainName: '',


  version:'1.0.8',
  disableDevToolsDetector: false,
};
